import { CollectDataStepType } from 'src/constants/collect-data/enums'
import { stepLabel } from 'src/constants/collect-data/stepTypeLabels'
import type { PartnerDriverStep } from 'src/interfaces/partnerDriver'

const VEHICLE_INFORMATION_LABEL = 'Vehicle Information'

// Retool parity: `item.label || stepNameMap[type]`. `collectDataStepsConfig.label` names the step
// GROUP, so it is deliberately not a fallback here. Templates often store the type key itself as
// the label (`sign_contract`), which is not a display name either.
const resolveBaseLabel = (step: PartnerDriverStep): string => {
  const label = (step.label ?? '').trim()

  if (label !== '' && label !== step.type) {
    return label
  }

  return stepLabel(step.type)
}

export const stepDisplayLabel = (step: PartnerDriverStep): string => {
  const baseLabel = resolveBaseLabel(step)

  if (step.type === CollectDataStepType.InsuranceCoverage) {
    const productName = (step.metadata?.insurancePolicyProduct?.product?.name ?? '').trim()

    if (productName !== '') {
      return `Insurance - ${productName}`
    }

    return baseLabel
  }

  if (step.type === CollectDataStepType.LMSTraining) {
    const trainingName = (step.metadata?.lmsTrainingName ?? '').trim()

    if (trainingName !== '') {
      return `LMS Training - ${trainingName}`
    }

    return baseLabel
  }

  if (step.type === CollectDataStepType.VehicleInsurance && step.metadata?.disableInsuranceUpload) {
    return VEHICLE_INFORMATION_LABEL
  }

  return baseLabel
}
